export default {
  data () {
    return {
      paginator: {
        actualPage: 0,
        totalPage: null, // Numbers of pages
        perPage: 15,
        totalRegister: null // Count total registers
      }
    }
  },
  methods: {
    goToNextPage () {
      const nextPage = this.paginator.actualPage + 1
      if (nextPage >= this.paginator.totalPage) return
      this.paginator.actualPage++
    },
    goToPreviousPage () {
      const previousPage = this.paginator.actualPage - 1
      if (previousPage < 0) return
      this.paginator.actualPage--
    },
    goToPage (pPage) {
      if (pPage < 0 || pPage > this.paginator.totalPage) return
      this.paginator.actualPage = pPage
    },
    buildQuery ({ filters } = {}) {
      const skip = this.paginator.actualPage * this.paginator.perPage
      const limit = this.paginator.perPage

      const query = {
        skip,
        limit
      }
      if (filters) query.filters = filters
      return query
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/primitives/paginator/source-paginator-mixin/index.js